// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-autoship-paused[data-v-ea6539fa]{background:var(--neutral-surface-shade-98-30) !important}.product-autoship-paused[data-v-ea6539fa]  .title-container{color:var(--primary-text-primary)}.product-autoship-paused[data-v-ea6539fa]  .units-container .unit-value{color:var(--neutral-text-caption-negative) !important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
